import { render } from "./MaintenanceOverviewPanel.vue?vue&type=template&id=80d07136&scoped=true&ts=true"
import script from "./MaintenanceOverviewPanel.vue?vue&type=script&lang=ts"
export * from "./MaintenanceOverviewPanel.vue?vue&type=script&lang=ts"

import "./MaintenanceOverviewPanel.vue?vue&type=style&index=0&id=80d07136&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d07136"]])

export default __exports__